import { BOOK } from "../../utils/constants";
import { get, post, put } from "../../utils/axios-config";
import { BookType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";

export const createBook = async (data: BookType) => await post(BOOK, data);

export const updateBook = async (data: BookType) => await put(BOOK, data);

export const getBooks = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "10",
    });
    const url = `${BOOK}?${queryParams.toString()}`;
    return await get<PagedResultsType<BookType>>(url);
};
